import {AffiliationInfo} from '../../backend/interfaces/affiliation-info';
import {Me} from '../../backend/interfaces/me';
import {Permission} from '../../backend/interfaces/permission';
import {RelationshipInfo} from '../../backend/interfaces/relationship-info';
import {Session} from '../../interfaces/session';
import {PermissionsKV, SessionAffiliationInfo} from '../../interfaces/session-affiliation-info';

export function createSessionData({
  me,
  selectedRelationship,
  selectedAffiliation,
}: {
  me: Me;
  selectedRelationship?: RelationshipInfo;
  selectedAffiliation?: AffiliationInfo;
}): Session {
  const affiliations = me.affiliations.map(convertAffiliationInfo2SessionAffiliationInfo);
  const affliation =
    selectedAffiliation && convertAffiliationInfo2SessionAffiliationInfo(selectedAffiliation);

  return {
    id: me.user.id ? me.user.id : '',
    currentUser: me.user,
    affiliations: affiliations,
    relationships: me.relationships,
    unreadNotificationsCount: me.unreadNotificationsCount,
    productConfiguration: me.productConfiguration ? me.productConfiguration : undefined,
    externalAccounts: me.externalAccounts,
    systemAdministratorProfile: me.systemAdministratorProfile,
    partnerProfile: me.partnerProfile,
    selectedRelationship:
      selectedRelationship ?? (me.relationships.length > 0 ? me.relationships[0] : undefined),
    selectedAffiliation: affliation ?? (affiliations.length > 0 ? affiliations[0] : undefined),
  };
}

// --------------------------------------------------------------------------------------------
// --------------------------------------------------------------------------------------------
// --------------------------------------------------------------------------------------------

function convertAffiliationInfo2SessionAffiliationInfo(
  affiliationInfo: AffiliationInfo
): SessionAffiliationInfo {
  return {
    ...affiliationInfo,
    rolesPermissionsOverviewKV: convertRolesPermissionsOverriewArrayIntoKV(
      affiliationInfo.rolesPermissionsOverview
    ),
  };
}

function convertRolesPermissionsOverriewArrayIntoKV(
  rolesPermissionsOverview: Permission[] | undefined
): PermissionsKV | undefined {
  return rolesPermissionsOverview?.reduce((acc, permission) => {
    acc[permission.type] = {
      canRead: permission.canRead ?? false,
      canWrite: permission.canWrite ?? false,
    };

    return acc;
  }, {} as PermissionsKV);
}
